import { Component, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Station } from 'src/tmc-yard/client/model/station';
import { StationSet } from 'src/tmc-yard/client/model/station-set';
import { StructureSelctionFilter, StructureSelectionContext, StructureSelectionDialogScope } from '../../../structure-selection.model';
import { StationType } from 'src/tmc-yard/client/model/station-type.enum';

@Component({
    selector: 'app-station-set-details',
    templateUrl: './station-set-details.component.html',
    styleUrls: ['./station-set-details.component.scss']
})
export class StationSetDetailsComponent implements OnDestroy {

    selectionContext: StructureSelectionContext;

    stationSet: StationSet;

    selectedStation: Station;

    showStations = false;

    selectionChangeSubscription: Subscription;

    filteredStations = new Array<Station>();

    @Input("context") set setSelectionContext(value: StructureSelectionContext) {
        this.selectionContext = value;
        this.selectionChangeSubscription = value.selectionChange$.subscribe(() => {
            this.updateSelection();
            this.updateFilteredStations();
        });
        this.updateSelection();
        this.updateFilteredStations();
    }


    @Input('stationSet') set setStationSet(stationSet: StationSet) {
        this.stationSet = stationSet;
        this.updateSelection();
        this.updateFilteredStations();
    }

    ngOnDestroy(): void {
        if (this.selectionChangeSubscription != null) {
            this.selectionChangeSubscription.unsubscribe();
            this.selectionChangeSubscription = null;
        }
    }

    updateSelection() {
        if (this.stationSet != null && this.selectionContext != null) {
            this.showStations = this.selectionContext.scope === StructureSelectionDialogScope.ANY ||
                this.selectionContext.scope === StructureSelectionDialogScope.STATION ||
                this.selectionContext.scope === StructureSelectionDialogScope.STATION_OR_STATION_SET;
            const selection = this.selectionContext.selection;
            if (selection.stationId != null) {
                for (const station of this.stationSet.stations) {
                    if (station.id === selection.stationId) {
                        this.selectedStation = station;
                    }
                }
            } else {
                this.selectedStation = null;
            }
        }
    }

    updateFilteredStations() {
        if (this.selectionContext != null && this.stationSet != null) {
            if (this.selectionContext.filter === StructureSelctionFilter.STATION) {
                this.filteredStations = this.stationSet.stations.filter(s => s.stationType === StationType.WORKING_AREA);
            } else if (this.selectionContext.filter === StructureSelctionFilter.WAITING_AREA) {
                this.filteredStations = this.stationSet.stations.filter(s => s.stationType === StationType.WAITING_AREA);
            } else {
                this.filteredStations = this.stationSet.stations;
            }
        }
    }

    selectStation(station: Station) {
        if (station === this.selectedStation) {
            this.selectionContext.setStationSelection(null);
        } else {
            this.selectionContext.setStationSelection(station.id);
        }
    }

}
